import React from 'react';
import FollowupInput from './FollowupInput';
import { iFollowupItem } from 'interfaces/iFollowupItem';
import { LoadingFeedback } from 'components/Common/LoadingModal';

interface FollowupQuestionsDisplayProps {
  followupItems: iFollowupItem[];
  onSubmitFollowup: any;
  isStreaming: boolean;
  userProductDesc?: string;
  material?: string;
  intendedUse?: string;
  physicalState?: string;
}

const FollowupQuestionsDisplay: React.FC<FollowupQuestionsDisplayProps> = ({
  followupItems,
  onSubmitFollowup,
  isStreaming,
  userProductDesc,
  material,
  intendedUse,
  physicalState
}) => {
  return (
    <>
      <div className='classify'>
        <div className='classify-found'>
          <div className='classify-header'>
            Product Name / Product Description
          </div>
          <div className='classify-cont'>
            <div className='classify-cont-sec'>
              <div className='classify-cont-sec-div'>
                <div className='classify-cont-sec-input'>{userProductDesc}</div>
              </div>
            </div>
            <div style={{ marginTop: '15px', borderTop: '1px solid var(--border-color)', paddingTop: '15px', width: '100%' }}>
          <div className='classify-header' style={{ fontSize: '12px', opacity: 0.8 }}>
            Optional Details (Improves Accuracy)
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '10px', marginTop: '10px' }}>
            <div style={{ width: 'inherit' }}>
              <label style={{ fontSize: '11px', display: 'block', marginBottom: '4px' }}>Material</label>
              <input 
                className='classify-cont-sec-input' 
                style={{ padding: '8px' }}
                placeholder='e.g. Steel, Cotton'
                value={material}
                disabled
              />
            </div>
            <div style={{ width: 'inherit' }}>
              <label style={{ fontSize: '11px', display: 'block', marginBottom: '4px' }}>Intended Use</label>
              <input 
                className='classify-cont-sec-input' 
                style={{ padding: '8px' }}
                placeholder='e.g. Medical, Filtration'
                value={intendedUse}
                disabled
              />
            </div>
            <div style={{ width: 'inherit' }}>
              <label style={{ fontSize: '11px', display: 'block', marginBottom: '4px' }}>Physical State</label>
              <input 
                className='classify-cont-sec-input' 
                style={{ padding: '8px' }}
                placeholder='e.g. Liquid, Finished'
                value={physicalState}
                disabled
              />
            </div>
          </div>
        </div>
          </div>
        </div>

        {isStreaming && followupItems.length > 0 ? (
          <>
            <div className='classify-follow-up'>
              Processing Follow-Up Questions
            </div>
            <LoadingFeedback size='small' />
          </>
        ) : (
          <>
            <div className='classify-follow-up'>
              Generated Follow-Up Questions
            </div>
            <FollowupInput
              followupItems={followupItems}
              isStreaming={isStreaming}
              onSubmitFollowup={onSubmitFollowup}
            />
          </>
        )}
      </div>
    </>
  );
};

export default FollowupQuestionsDisplay;
